import React, { type FC } from "react";
import { useDivisionFilterSeed } from "@app/session-defaults/useDivisionFilterSeed";
import { BoType } from "@src/api/bo";
import { DivisionType } from "@src/api/dictionaries/divisions";
import { BoStateSelect, DivisionSearchSelect } from "@src/components/business-data-entry";
import { BusinessForm } from "@src/components/business-form";
import { FilterFormPanel } from "@shared/ui/form-panel";
import { Input } from "@shared/ui/input";
import type { StockActInvFilter } from "../../../../../../api/stockActInvs";
import type { ListFilterPanelProps } from "../../../../../../shared/listFilterPanel";
import {
    stockFullInventoryFilterFormConfig,
    type StockFullInventoryFilterFormValues,
} from "./stockFullInventoryFilter.form-config";

/** Пропсы компонента {@link StockFullInventoryFilterForm}. */
export type StockFullInventoryFilterFormProps = ListFilterPanelProps<StockActInvFilter>;

/** Форма фильтра списка АИ для полной инвентаризации склада. */
export const StockFullInventoryFilterForm: FC<StockFullInventoryFilterFormProps> = ({ initialFilter, onApply }) => {
    const seed = useDivisionFilterSeed<StockFullInventoryFilterFormValues>("divisionCode", {
        filter: { Types: [DivisionType.Склад] },
    });

    return (
        <FilterFormPanel
            initialFilter={initialFilter}
            seed={seed}
            submissionMemory={{
                key: "stock.fullInventory.filter",
                schemaVersion: 1,
                fields: ["divisionCode", "stateCodes"],
            }}
            formProps={{ formConfig: stockFullInventoryFilterFormConfig }}
            toForm={(filter) => stockFullInventoryFilterFormConfig.toForm(filter)}
            toDomain={(values) => stockFullInventoryFilterFormConfig.toDomain(values)}
            onApply={onApply}
        >
            {(form) => (
                <>
                    <BusinessForm.Field name="divisionCode">
                        <DivisionSearchSelect
                            {...form.field("divisionCode").getSearchSelectProps((division) => division?.Code ?? null)}
                            flt={{ Types: [DivisionType.Склад] }}
                            fullscreenTitle="Выберите Склад АИ"
                        />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="num">
                        <Input {...form.field("num").getPropsWithLabel()} />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="stateCodes">
                        <BoStateSelect
                            {...form.field("stateCodes").getControlledPropsWithLabel()}
                            boType={BoType["Акт инвентаризации"]}
                            multiple
                            clearable
                            fullscreenTitle="Выберите статус(ы) АИ"
                        />
                    </BusinessForm.Field>
                </>
            )}
        </FilterFormPanel>
    );
};
